import React from 'react';
import {
  Checkbox as ChakraCheckbox,
  CheckboxProps,
  Grid,
  Text
} from '@chakra-ui/react';
import { getIconColor, styles } from './checkbox.styles';
import theme from '../../theme';

export enum CheckboxVariant {
  OUTLINED = 'outlined',
  CONTAINED = 'contained',
  CIRCULAR_OUTLINED = 'circularOutlined',
  CIRCULAR_CONTAINED = 'circularContained'
}

export enum CheckboxSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg'
}

export type CMXCheckboxProps = {
  label?: string;
  isChecked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  variant?: CheckboxVariant;
  disabled?: boolean;
  defaultChecked?: boolean;
  _className?: any;
  checkboxColor?: string;
  size?: CheckboxSize;
  dataTestId?: string;
  onClick?: () => void;
} & CheckboxProps;

const Checkbox: React.FC<CMXCheckboxProps> = ({
  dataTestId,
  label,
  onChange,
  onClick,
  textColor,
  _className = '',
  checkboxColor = theme.colors.foundation[300],
  defaultChecked = false,
  disabled = false,
  isChecked = false,
  size = CheckboxSize.MD,
  variant = CheckboxVariant.CONTAINED,
  ...props
}) => {
  const classes = styles(checkboxColor, variant);
  const iconColor = getIconColor(checkboxColor, variant);

  const handleGridClick = (e: React.MouseEvent) => {
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <Grid
      display="flex"
      flexDirection="row"
      alignItems="center"
      onClick={e => {
        handleGridClick(e);
      }}>
      <ChakraCheckbox
        isChecked={isChecked}
        isDisabled={disabled}
        size={size}
        defaultChecked={defaultChecked}
        sx={{ ...classes, ..._className }}
        iconColor={iconColor}
        onChange={onChange}
        data-testid={dataTestId?.trim() ?? 'checkbox'}
        {...props}>
        <Text
          noOfLines={1}
          color={textColor ?? theme.colors.text['highEmphasis']}>
          {label}
        </Text>
      </ChakraCheckbox>
    </Grid>
  );
};

Checkbox.displayName = 'Checkbox';

export { Checkbox };
